export default { sha: 'b6c9f33ecaf57c4bcb1c731c3d8935dc16968723', buildNumber: 'undefined' }
